"use client";

import { OTPContext, OTPContextProvider, OTPContextWrapper } from "@/components/sections/CommonModals/context";
import styles from "./LeadForm.module.scss";
import { useCallback, useRef, useState } from "react";
import HomeConnectModalForm from "@/revamp/molecules/HomeConnectModalForm";
import { pushToDataLayer } from "@/helpers/gtag";
import { updateStateSession } from "@/context/utils";
const LeadFormWrapper = ({
    associatedPrograms=[],
    isLambdaAPI=false,
}) => {

    const [message, setMessage] = useState(false);
    const [isOtpValidated, setIsOtpValidated] = useState(false);
    const [ leadFailed, setLeadFailed ] = useState(false);
    const [formResponse, setFormResponse] = useState(null);
    const clickedInsideLeadForm = useRef(false);
  
    const handleClickInsideLeadForm = (e) => {
        if (!clickedInsideLeadForm.current) {
          
          pushToDataLayer(
            {
              event :	"lead_initiate",
              cta_text : "Apply Now",
              section_name : "footer_sticky",
              header_title : "NA",
              page_type	: "Home Page",
              page_url : window.location.href || "NA"
            }
          )
          updateStateSession(
            {
              parentSection : "footer_sticky"
            }
          )
          clickedInsideLeadForm.current =true;
        }
      };

    const handleOtpValidation = useCallback((status) => {
		setIsOtpValidated(status);
	}, []);

    const handleLeadCheck = useCallback((status: boolean) => { 
        console.log(status,"status");
        
        setLeadFailed(status)
    },[])

  return (
        <section className={styles.root} onClick={handleClickInsideLeadForm}>
           <div className={styles.formSection}>
                <OTPContextProvider isLambdaAPI={isLambdaAPI} >
                    <OTPContext.Consumer>
                    {({ isHeaderHidden }) => (
                        <>
                        {!isHeaderHidden && (<h2>Apply Now</h2>)}
                        <OTPContextWrapper isDarkForm={true}>
                            <HomeConnectModalForm
                                setMessage={setMessage}
                                setFormResponse={setFormResponse}
                                isOtpValidated={handleOtpValidation}
                                associatedPrograms={associatedPrograms}
                                isNewLeadForm={true}
                                checkLeadFail={handleLeadCheck}
                                isLambdaAPI={isLambdaAPI}
                            />
                        </OTPContextWrapper>
                        </>
                    )}
                    </OTPContext.Consumer>
                </OTPContextProvider>
            </div>
        </section>
    )
}

export default LeadFormWrapper;
